import { MediaObject } from './MediaObject';

// TODO: in v9, move styled() from MediaObject.jsx to here
export var StyledMediaObject = MediaObject;